import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
`;

export const ContainerGraph = styled.div`
    display: flex;
    height: 350px;
    width: 100%;
`;

export const NoDataContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`

export const NoDataText = styled.span`
    color: #333;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
`;

export const ButtonsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
    margin: auto;
    width: max-content;
`;

export const NumberInput = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 48px;
    border-radius: 3.802px;
    border: 1.14px solid #C4C4C4;
    outline: none;
    height: 24px;
    background: #FFF;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: #333;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    line-height: 0;
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
`;

export const Text = styled.h1`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    text-align: left;
    max-width: 100%;
    white-space: nowrap;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;